import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Q",
  "use": "icon-Q-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Q\">\n<path d=\"M28.4886 36.472L11.3526 19.336C10.6806 18.664 9.57656 18.664 8.90456 19.336C8.56856 19.672 8.37656 20.104 8.37656 20.584C8.37656 21.016 8.56856 21.448 8.90456 21.784L25.9926 38.92C28.1526 41.08 31.7046 41.08 33.8646 38.92L51.1446 21.64C51.8166 20.968 51.8166 19.864 51.1446 19.144C50.4726 18.472 49.3686 18.472 48.6966 19.144L31.4166 36.472C30.6006 37.288 29.2566 37.288 28.4886 36.472Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol